import { StyleSheet } from 'aphrodite/no-important';
var styles = StyleSheet.create({
    errorContainer: {
        padding: 50,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    text: {
        margin: '20px 0'
    },
    image: {
        maxWidth: 350,
        marginBottom: 40
    },
    button: {
        paddingRight: 30,
        paddingLeft: 30
    }
});
export default styles;
